import { Component, OnInit, OnDestroy } from '@angular/core';
import { catchError, first, forkJoin, of, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { News } from 'src/app/classes/news';
import { NewsService } from 'src/app/services/news.service';
import { MyFile } from 'src/app/classes/fileInfo';
import { CategoryService } from 'src/app/services/news-category.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FileService } from 'src/app/services/file.service';



@Component({
	selector: 'app-news-viewer',
	templateUrl: './news-viewer.component.html',
	styleUrls: [ './news-viewer.component.css' ]
})
export class NewsViewerComponent implements OnInit, OnDestroy {


	bLoading = true;
	subscriptions = new Subscription();
	
	bError = false;
	news = new News();
	
	bExternal = false;
	attachedFiles: MyFile[] = [];
	strRubrics = "";
	strCategories = "";


	constructor(
		private activatedRoute: ActivatedRoute,
		private newsService: NewsService,
		private fileService: FileService,
		private categoryService: CategoryService,
		public domSanitizer: DomSanitizer
	) {}


	ngOnInit() {

		forkJoin( {
			rubrics: this.newsService.getRubrics(),
			// first(): get only the first, otherwise the obs never stops and forkJoin hangs
			routeParams: this.activatedRoute.queryParams.pipe( first() ),		
			news: this.newsService.getNews()
		} ).pipe(
			catchError( err => of(null) )
		).subscribe( response => {

			this.bLoading = false;
			
			if( !response || !response.routeParams['id'] ) {
				this.bError = true;
				return;
			}

			const news = response.news;
			if( !news || !news.length ) {
				this.bError = true;
				return;
			}

			const existingNews = news.find( n => n.id == response.routeParams['id'] );
			if( !existingNews ) {
				this.bError = true;
				return;
			}
			this.news = existingNews;

			if( existingNews.url ) {
				window.open( existingNews.url );
				return;
			}

			const rubrics = response.rubrics.sort( (a,b) => a.name.localeCompare( b.name ) );
			this.strRubrics = existingNews.rubrics
				.map( rId => rubrics.find( r => r.id == rId )?.name || rId )
				.join( ", " );

			const categories = this.categoryService.getCategoriesInCache();
			this.strCategories = existingNews.categories
				.map( cId => categories.find( c => c.kategorieId == cId )?.bezeichnung || cId )
				.join( ", " );

			existingNews.myFiles.sort( (a,b) => a.file.name.localeCompare( b.file.name ) );
						
		});

	}

	ngOnDestroy() {
		
		this.subscriptions.unsubscribe();

	}


	downloadFile( attachedFile: MyFile ) {

		this.fileService.downloadFileById( attachedFile.id, attachedFile.file.name );

	}


}
